import http from '@/http.js'

export default class PortfolioService {
  GetDistinctPortfolios () {
    return new Promise((resolve, reject) => {
      http.get(`/api/transaction/portfolios/distinct`)
      .then((response) => { resolve(response.data) })
      .catch((error) => reject(error))
    })
  }

}